import {
  Flex, FlexColumn,
  SelectInput,
} from '@equifinance/shared';
import styled from 'styled-components';
import { DecisionOutcome, Task } from '../../../contexts/tasks';

const UnderwriterDecisionContainer = styled(FlexColumn)``;

const UnderwriterDecisionHeader = styled(Flex)`${({ theme }) => `
  background-color: ${theme.colours.primary[3]};
  border-radius: ${theme.borderRadius[2]};
  padding: ${theme.padding[2]};
  align-items: center;
  justify-content: space-between;
`}`;

const UnderwriterDecisionHeaderTitle = styled(Flex)`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
  font-size: ${theme.fontSize[3]};
  font-family: 'Montserrat';
  font-weight: ${theme.fontWeight.bolder};
  padding-left: ${theme.padding[3]};
`}`;

const UnderwriterDecisionHeaderSection = styled(Flex)`${({ theme }) => `
  width: ${theme.dropdownWidth};
`}`;

const UnderwriterDecisionBody = styled(FlexColumn)``;

export default function UnderwriterDecision({
  task,
  selectedDecision,
  onChangeDecision,
  disabled,
}: {
  task: Task,
  selectedDecision: keyof typeof DecisionOutcome,
  onChangeDecision: (value: string) => void,
  disabled: boolean,
}) {
  const possibleDecisions = task.possibleDecisionOutcomes.reduce((acc, d) => ({ ...acc, [d]: DecisionOutcome[d] }), {});

  return (
    <UnderwriterDecisionContainer>
      <UnderwriterDecisionHeader>
        <UnderwriterDecisionHeaderTitle>{'Underwriter\'s decision'}</UnderwriterDecisionHeaderTitle>
        <UnderwriterDecisionHeaderSection>
          <SelectInput
            id={`underwriter-decision-${task.id}`}
            options={possibleDecisions}
            value={selectedDecision}
            onChange={onChangeDecision}
            disabled={disabled}
          />
        </UnderwriterDecisionHeaderSection>
      </UnderwriterDecisionHeader>
      <UnderwriterDecisionBody />
    </UnderwriterDecisionContainer>
  );
}
